export interface FuelSupplierGetRecord {
  id: number;
  name: string;
  stationManager: string;
  address: string;
  sapId: number;
  remarks: string;
  contactId: number;
  contactMediaNo: number;
  contactMediaType: string;
  contactType: string;
  contactDetails: string;
  attachmentsCount: number;
}
